import { render, staticRenderFns } from "./createVoucher.vue?vue&type=template&id=654c489a&scoped=true"
import script from "./createVoucher.vue?vue&type=script&lang=js"
export * from "./createVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c489a",
  null
  
)

export default component.exports